module.exports = __webpack_public_path__ + "static/media/DSC_0170.aa7e0b95.jpg";